import FileUploadButton from "../../../../utils/FileUploadButton";
import UploadedFileNote from "../../../../utils/UploadedFileNote";

import { FieldLabel } from "../../shared/practitionerForm.styles";
import { ACCEPTED_FILE_TYPES } from "../IPHCPractitionerModal.constants";

const ComplianceDocumentField = ({
  label,
  id,
  file,
  onChange,
  onDelete,
  multiple = false,
  uploadLabel,
}) => {
  return (
    <>
      <FieldLabel>{label}</FieldLabel>
      <FileUploadButton
        id={id}
        label={uploadLabel || `Upload ${label}`}
        accept={ACCEPTED_FILE_TYPES}
        onChange={onChange}
        multiple={multiple}
        style={{ width: "100%" }}
      />
      <UploadedFileNote file={file} onDelete={onDelete} />
    </>
  );
};

export default ComplianceDocumentField;
